import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import Highlight from '../component/Highlight';
import ProductList from '../container/ProductList';
import ProductCard from '../component/ProductCard';
import { Link } from 'react-router-dom';

export default class Content extends React.Component {

    render() {
        const brStyle = {
            minHeight: '800px',
            padding: '400 0 500 0'
        };

        return (
            <div style={brStyle} >


                <Highlight />

                {/*remove these code after demo*/}
                <div className="container py-4 py-lg-6">
                    <hr className="hr-lg mt-0 mb-3 w-10 mx-auto hr-primary" />
                    <h2 className="text-center text-uppercase font-weight-bold my-0">{this.props.getTranslatedText("FeaturedProducts")}</h2>
                    <h5 className="text-center font-weight-light mt-2 mb-0 text-muted">{this.props.getTranslatedText("GreatProducts")}</h5>
                    <hr className="mb-5 w-50 mx-auto" />
                    <div className="card-deck-wrapper">
                        <div className="card-deck">
                            {/*<!-- Product 1 -->*/}
                            <div className="card product-card overlay-hover">
                                {/*<!-- Image & price content -->*/}
                                <div className="pos-relative">
                                    <Link to={"/products/Gas-Flow-Meter/Sensus/"}>
                                        <img className="card-img-top img-fluid" src="./img/products/sensus_meter.jpg" alt="Card image cap" />
                                        <span className="badge badge-primary product-price-badge pos-absolute pos-t pos-r mt-2 mr-2 persist"></span>
                                    </Link>
                                </div>
                                {/*<!-- Content -->*/}
                                <div className="card-block">
                                    <Link to={"/products/Gas-Flow-Meter/Sensus/"}>
                                        <h4 className="card-title">Sensus</h4>
                                    </Link>
                                    <p className="card-text">Gas Meter</p>
                                </div>
                            </div>
                            {/*<!-- Product 2 -->*/}
                            <div className="card product-card overlay-hover">
                                {/*<!-- Image & price content -->*/}
                                <div className="pos-relative">
                                    <Link to={"/products/Burner-Controls/Black-Teknigas/"}>
                                        <img className="card-img-top img-fluid" src="./img/products/black-teknigas-thermocouples.jpg" alt="Card image cap" />
                                    </Link>
                                </div>
                                {/*<!-- Content -->*/}
                                <div className="card-block">
                                    <Link to={"/products/Burner-Controls/Black-Teknigas"}>
                                        <h4 className="card-title">Black Teknigas</h4>
                                    </Link>
                                    <p className="card-text">Thermocouples</p>
                                </div>

                            </div>
                            {/*<!-- Product 3 -->*/}
                            <div className="card product-card overlay-hover">
                                {/*<!-- Content -->*/}
                                <div className="pos-relative">
                                    <Link to={"/products/Governor/Maxitrol"}>
                                        <img className="card-img-top img-fluid" src="./img/products/maxitrol-zerogovernors.jpg" alt="Card image cap" />
                                    </Link>
                                </div>
                                <div className="card-block">
                                    <Link to={"/products/Governor/Maxitrol"}>
                                        <h4 className="card-title">Maxitrol</h4>
                                    </Link>
                                    <p className="card-text">Governor</p>
                                </div>
                            </div>
                        </div>
                        <div className="card-deck">
                            <div className="card product-card overlay-hover">
                                {/*<!-- Content -->*/}
                                <div className="pos-relative">
                                    <Link to={"/products/vaporizer/Kosangas"}>
                                        <img className="card-img-top img-fluid" src="./img/products/vaporizer_edit.jpg" alt="Card image cap" />
                                    </Link>
                                </div>
                                <div className="card-block">
                                    <Link to={"/products/vaporizer/Kosangas"}>
                                        <h4 className="card-title">Kosan</h4>
                                    </Link>
                                    <p className="card-text">Vaporiser</p>
                                </div>
                            </div>
                            <div className="card product-card overlay-hover">
                                {/*<!-- Content -->*/}
                                <div className="pos-relative">
                                    <Link to={"/products/Automatic-Change-Over/Katsura"}>
                                        <img className="card-img-top img-fluid" src="./img/products/katsura_automatic_regulator.jpg" alt="Card image cap" />
                                    </Link>
                                </div>
                                <div className="card-block">
                                    <Link to={"/products/Automatic-Change-Over/Katsura"}>
                                        <h4 className="card-title">Katsura</h4>
                                    </Link>
                                    <p className="card-text">Automatic Regulator</p>
                                </div>
                            </div>
                            <div className="card product-card overlay-hover">
                                {/*<!-- Content -->*/}
                                <div className="pos-relative">
                                    <Link to={"/products/Rubber-Hose/Itokoki"}>
                                        <img className="card-img-top img-fluid" src="./img/products/itokoki-hoses.jpg" alt="Card image cap" />
                                    </Link>
                                </div>
                                <div className="card-block">
                                    <Link to={"/products/Rubber-Hose/Itokoki"}>
                                        <h4 className="card-title">Itokok</h4>
                                    </Link>
                                    <p className="card-text">LPG high pressure gas hose</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Content.js